import { mapState } from "vuex";
export default {
  data() {
    return {
      debugGtm: false
    }
  },
  computed: {
    ...mapState({
      config: state => state.configurator.config,
      currentStep: state => state.configurator.currentStep,
      qtyAddedToCart: state => state.configurator.qtyAddedToCart,
      qtyDesignsSaved: state => state.configurator.qtyDesignsSaved,
      selectedOptions: state => state.configurator.selectedOptions,
      quantity: state => state.configurator.quantity
    }),
    activeSteps() {
      return this.$store.getters["configurator/activeSteps"];
    },
    subtotal() {
      return this.$store.getters["configurator/subtotal"];
    }
  },
  methods: {
    getStepNumber(stepId) {
      return this.activeSteps.map(step => step.id).indexOf(stepId) + 1;
    },
    getStepById(stepId) {
      return this.activeSteps.filter(s => s.id === stepId)[0] || null;
    },
    getStepTitleById(stepId) {
      let step = this.getStepById(stepId);
      return step ? step.title : "";
    },
    getStepOptions(stepId) {
      let step = this.getStepById(stepId);
      return step.options ? this.config.options.filter(opt => step.options.includes(opt.id)) : [];
    },
    isSelectionChanged(stepId) {
      let options = this.getStepOptions(stepId).filter(opt => {
        let selectedValue = this.selectedOptions[opt.input.name] ? this.selectedOptions[opt.input.name].value : null;
        let defaultValue = opt.input.default || null;
        return selectedValue !== defaultValue;
      });
      return options.length ? 'true' : 'false';
    }
  },
  watch: {
    qtyAddedToCart: function () {
      let dataLayer = (window.dataLayer = window.dataLayer || [])

      // When Add to Cart is clicked, push 'visualizer-SelectionMade' event
      let addToCart = {
        'event': 'visualizer-addToCart',
        'visualizer-addToCartLocation': 'Visualizer',
        'visualizerProductName': this.config.product.name,
        'visualizerParentProductSku': this.config.product.parentSku,
        'visualizerProductSku': this.config.product.sku,
        'ecommerce': {
          'currencyCode': 'USD',
          'add': {
            'products': [{
              'name': this.config.product.name,
              'id': this.config.product.parentSku,
              'variant': this.config.product.sku,
              'price': this.subtotal,
              'quantity': this.quantity
            }]
          }
        }
      };
      if (this.debugGtm) console.log(addToCart);
      dataLayer.push(addToCart);
    },
    qtyDesignsSaved: function () {
      let dataLayer = (window.dataLayer = window.dataLayer || [])

      // When design is saved, push 'visualizer-saveDesign' event
      let saveDesign = {
        'event': 'visualizer-saveDesign',
        'visualizerProductName': this.config.product.name,
        'visualizerParentProductSku': this.config.product.parentSku,
        'visualizerProductSku': this.config.product.sku,
        'visualizerProductPrice': this.subtotal
      };
      if (this.debugGtm) console.table(saveDesign);
      dataLayer.push(saveDesign);
    },
    currentStep: function (currentStepId, previousStepId) {

      let dataLayer = (window.dataLayer = window.dataLayer || [])

      // When moving to next step, push 'visualizer-SelectionMade' event
      if (previousStepId && this.getStepNumber(previousStepId) < this.getStepNumber(currentStepId)) {
        let selectionMade = {
          'event': 'visualizer-SelectionMade',
          'visualizerProductName': this.config.product.name,
          'visualizerParentProductSku': this.config.product.parentSku,
          'visualizerProductSku': this.config.product.sku,
          'visualizerStepNumber': this.getStepNumber(previousStepId),
          'visualizerTotalSteps': this.activeSteps.length,
          'visualizerStepName': this.getStepTitleById(previousStepId),
          'visualizerSelectionChanged': this.isSelectionChanged(previousStepId)
        };
        if (this.debugGtm) console.table(selectionMade);
        dataLayer.push(selectionMade);
      }

      // When step changes, push 'visualizer-StepLoaded' event
      let stepLoaded = {
        'event': 'visualizer-StepLoaded',
        'visualizerProductName': this.config.product.name,
        'visualizerParentProductSku': this.config.product.parentSku,
        'visualizerProductSku': this.config.product.sku,
        'visualizerStepNumber': this.getStepNumber(currentStepId),
        'visualizerTotalSteps': this.activeSteps.length,
        'visualizerStepName': this.getStepTitleById(currentStepId),
      };
      if (this.debugGtm) console.table(stepLoaded);
      dataLayer.push(stepLoaded);
  
    }
  }
};
